






































import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum';
import { CatalogFieldConfig } from '@empathybroker/tsclient-play/dist/models/instance/catalog-field-config';
import { RankingElement } from '@empathybroker/tsclient-play/dist/models/ranking-element';

import { mapGetters } from 'vuex';

import { ColorEnum } from '../../enums';

import { capitalizeSentence } from '../../filters';

import { CONFIG_CONSTS } from '../../store/config/config.consts';

import EpbButton from '../button.component.vue';
import { UiSelect, UiTextbox } from '../keen-ui';
import RankingElementsList from './ranking-elements-list.component.vue';

export default {
  name: 'attributes-ranking',
  props: {
    attributes: {
      type: Object,
      required: true
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    UiSelect,
    UiTextbox,
    EpbButton,
    RankingElementsList
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance
    }),
    fieldNameOptions: function () {
      return this.instanceConfig.catalog.fields.reduce((fieldNameOptions: any[], field: CatalogFieldConfig) => {
        if (field.rankable) {
          fieldNameOptions.push({
            value: field.id,
            label: capitalizeSentence(field.prettyName || field.id)
          });
        }
        return fieldNameOptions;
      }, []);
    },
    actionsDisabled: function (): boolean {
      return (!this.fieldName || !this.fieldValue || this.attributes.elements.some((element: RankingElement) =>
        (element.fieldValue === this.fieldValue) && (element.fieldName === this.fieldName.value)));
    }
  },
  data: function () {
    return {
      fieldName: '',
      fieldValue: '',
      RankingActionEnum
    };
  },
  methods: {
    getActionColor: function (action: RankingActionEnum): ColorEnum {
      return {
        [RankingActionEnum.BOOST]: ColorEnum.GREEN,
        [RankingActionEnum.BURY]: ColorEnum.RED
      }[action];
    },
    getActionText: function (action: RankingActionEnum): string {
      return {
        [RankingActionEnum.BOOST]: this.messages.actions.boost,
        [RankingActionEnum.BURY]: this.messages.actions.bury
      }[action];
    },
    addElement: function (action: RankingActionEnum): void {
      this.attributes.elements.push(
        {
          fieldName: this.fieldName.value,
          fieldValue: this.fieldValue,
          action: action,
          filters: {},
          schedule: {}
        } as RankingElement
      );
      this.fieldName = '';
      this.fieldValue = '';
    },
    getFieldNameText: function (fieldName: string): string {
      const fieldNameOption = this.fieldNameOptions.find(fieldNameOpt => (fieldNameOpt.value === fieldName));
      return (!!fieldNameOption ? fieldNameOption.label : fieldName);
    }
  }
};
